import { PRICE_UPDATE_INHERITING_STATES } from '@components/bid_request/RequestConstants';
import { useGetEventSeriesByBidRequest } from '@hooks/useEventSeries';
import { useBidRequestBusinessUnit } from '@features/price-update-business-unit/api/use-bid-request-business-unit';
import { InheritedBusinessUnitField } from './inherited-business-unit-field';
import type { ID } from 'types';

interface PriceUpdateEventBusinessUnitFieldProps {
  bidRequestId: ID | undefined;
  eventState?: string;
  open: boolean;
  savedBusinessUnit?: { name: string } | null;
}

/**
 * The edit drawer's locked business unit. An event still following its agreement shows the latest value
 * from the server, so a change made to the agreement elsewhere appears; any other event shows the one saved
 * on it.
 */
export const PriceUpdateEventBusinessUnitField = ({
  bidRequestId, eventState, open, savedBusinessUnit,
}: PriceUpdateEventBusinessUnitFieldProps) => {
  const { data: eventSeries } = useGetEventSeriesByBidRequest(bidRequestId, { enabled: open });
  const priceAgreementId = eventSeries === undefined ? undefined : eventSeries?.price_agreement_ref?.id ?? null;
  const followsAgreement = PRICE_UPDATE_INHERITING_STATES.includes(eventState ?? '');
  const { data: latestBusinessUnit } = useBidRequestBusinessUnit(bidRequestId, { enabled: open && followsAgreement });
  const businessUnit = latestBusinessUnit === undefined ? savedBusinessUnit : latestBusinessUnit;

  return (
    <InheritedBusinessUnitField
      isAgreementLinked={followsAgreement}
      priceAgreementId={priceAgreementId}
      storedBusinessUnit={{ name: businessUnit?.name ?? null }}
    />
  );
};
